import React from 'react';
import item from './../../assests/kitchen/item1.png';
import { RiCheckDoubleLine } from 'react-icons/ri';

import { motion } from 'framer-motion';

export default function Details() {
  const imageVariants = {
    hidden: {
      opacity: 0,
      y: '50%',
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        type: 'spring',
        stiffness: 120,
      },
    },
  };

  const detailsVariants = {
    hidden: {
      // opacity: 0,
      y: '100%',
    },
    visible: {
      // opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        type: 'spring',
        stiffness: 120,
        staggerChildren: 0.4,
        when: 'beforeChildren',
      },
    },
  };

  const childVariants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
    },
  };
  return (
    <div className="product-details">
      <motion.div
        variants={imageVariants}
        initial="hidden"
        animate="visible"
        className="product-details--img"
      >
        <img src={item} alt="item" />
      </motion.div>
      <motion.div
        variants={detailsVariants}
        initial="hidden"
        animate="visible"
        className="product-details--about"
      >
        <h2>
          Electronic Toaster
          <RiCheckDoubleLine />
        </h2>

        <motion.p variants={childVariants}>
          It has survived not only five centuries, but also the leap into
          electronic typesetting, remaining essentially unchanged. It was
          popularised in the 1960s with the release of Letraset sheets
          containing Lorem Ipsum passages, and more recently with desktop{' '}
        </motion.p>
        <motion.button variants={childVariants}>Add to cart</motion.button>
      </motion.div>
    </div>
  );
}
